import {computed, ref, watch} from "vue";

const useCharts = (series) => {
  const chartRef = ref(null);

  const chartReady = computed(() => chartRef.value?.chart !== null);

  const setSeriesVisibilities = (series) => {
    series.filter(seriesItem => seriesItem.visible === false).forEach((seriesItem) => {
      chartRef.value?.chart.hideSeries(seriesItem.name);
    });
  };

  watch(chartReady, () => {
    if (!chartReady.value) return;

    setSeriesVisibilities(series);
  }, {
    immediate: true,
  });

  return {
    chartRef,
    chartReady,
    setSeriesVisibilities,
  };
};

export default useCharts;